import { BaSeLogoSebraeInverse } from '@base/react';
import React from 'react';

import { Container, ContentLogo, ContentMenu } from './style';

import imglogo from '../../assets/tradicional.png';

function HeaderWithoutAuth() {
  return (
    <Container id="header">
      <ContentMenu>
        <BaSeLogoSebraeInverse width={60} />
        <ContentLogo>
          <img src={imglogo} width={138} height={29} alt="Logo  empretec" />
        </ContentLogo>
      </ContentMenu>
    </Container>
  );
}

export default HeaderWithoutAuth;
